module.exports = __webpack_public_path__ + "img/yyzxpos2.87fb461.png";